import { render } from "./CadastroPF_Passo_1.vue?vue&type=template&id=168637ba&scoped=true"
import script from "./CadastroPF_Passo_1.vue?vue&type=script&lang=js"
export * from "./CadastroPF_Passo_1.vue?vue&type=script&lang=js"

import "./CadastroPF_Passo_1.vue?vue&type=style&index=0&id=168637ba&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-168637ba"]])

export default __exports__